(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-header"]) return;
  try {
    
document.querySelectorAll('.sl-catalog').forEach(catalog=>{
 const summary=catalog.querySelector('summary');
 catalog.addEventListener('keydown',event=>{if(event.key==='Escape'&&catalog.open){catalog.open=false;summary.focus();event.preventDefault();}});
 document.addEventListener('click',event=>{if(!catalog.contains(event.target))catalog.open=false;});
});
document.addEventListener('click',event=>{
 const link=event.target.closest('a');
 if(!link||!link.closest('.sl-header,.sl-hero-carousel')||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const url=new URL(link.href,window.location.href);
 if(url.origin!==location.origin||!['#sl-art','#wall-clings','#sl-studio','#studio-apps','#studio-cartoons','#studio-projects','#studio-shop'].includes(url.hash))return;
 event.preventDefault();
 event.stopPropagation();
 document.querySelectorAll('.sl-catalog[open]').forEach(menu=>{menu.open=false;});
 const samePage=url.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'');
 const target=samePage?document.getElementById(url.hash.slice(1)):null;
 if(target){
  if(location.hash!==url.hash)history.pushState(null,'',url.hash);
  requestAnimationFrame(()=>{target.setAttribute('tabindex','-1');target.focus({preventScroll:true});target.scrollIntoView({behavior:'auto',block:'start'});});
 }else{
  location.assign(url.href);
 }
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-poster-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ss-gallery').forEach(gallery => {
  const track = gallery.querySelector('.ss-gallery-grid');
  const cards = [...track.children];
  const previous = gallery.querySelector('[data-poster-prev]');
  const next = gallery.querySelector('[data-poster-next]');
  const position = gallery.querySelector('.ss-carousel-position');
  const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
  const update = () => {
    const index = Math.round(track.scrollLeft / step());
    position.textContent = (index + 1) + ' / ' + cards.length;
    previous.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  };
  const move = direction => track.scrollBy({left:direction * step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  track.addEventListener('keydown', event => {if(event.target !== track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  window.addEventListener('resize',update);
  update();
});


(() => {
  const initialize = gallery => {
    if (gallery.dataset.viewerReady) return;
    gallery.dataset.viewerReady = 'true';
    const dialog = gallery.querySelector('.ss-artwork-dialog');
    const track = dialog.querySelector('.ss-artwork-track');
    const slides = [...track.querySelectorAll('.ss-artwork-slide')];
    const title = dialog.querySelector('h2');
    const previous = dialog.querySelector('[data-view-prev]');
    const next = dialog.querySelector('[data-view-next]');
    const label = dialog.querySelector('[data-view-label]');
    const position = dialog.querySelector('[data-view-position]');
    const links = [...gallery.querySelectorAll('[data-artwork-view]')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let opener = null, pushed = false, count = 1, index = 0, pageX = 0, pageY = 0;
    const update = () => {
      index = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      label.textContent = index ? dialog.dataset.roomLabel : dialog.dataset.artworkLabel;
      position.textContent = (index + 1) + ' / ' + count;
      if ((index === 0 && document.activeElement === previous) || (index === count - 1 && document.activeElement === next)) track.focus({preventScroll:true});
      previous.disabled = index === 0;
      next.disabled = index === count - 1;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
    };
    const open = link => {
      if (!dialog.open) {pageX = scrollX; pageY = scrollY;}
      opener = link;
      count = link.dataset.roomSrc ? 2 : 1;
      title.textContent = link.dataset.artworkTitle;
      const sources = [
        [link.dataset.artworkSrc, link.dataset.artworkAlt, link.dataset.artworkWidth, link.dataset.artworkHeight],
        [link.dataset.roomSrc, link.dataset.roomAlt, link.dataset.roomWidth, link.dataset.roomHeight]
      ];
      slides.forEach((slide, i) => {
        slide.hidden = i >= count;
        slide.setAttribute('aria-label', (i + 1) + ' / ' + count + ': ' + (i ? dialog.dataset.roomLabel : dialog.dataset.artworkLabel));
        const image = slide.querySelector('img');
        if (i < count) {
          image.src = sources[i][0];
          image.alt = sources[i][1];
          image.width = Number(sources[i][2]);
          image.height = Number(sources[i][3]);
        } else {image.removeAttribute('src'); image.alt = '';}
      });
      if (!dialog.open) dialog.showModal();
      track.scrollTo({left:0,behavior:'instant'});
      update();
      dialog.querySelector('.ss-artwork-back').focus({preventScroll:true});
    };
    const close = () => {
      if (!dialog.open) return;
      dialog.close();
      if (opener && opener.isConnected) opener.focus({preventScroll:true});
      window.scrollTo(pageX, pageY);
    };
    const dismiss = () => {
      close();
      if (pushed) {pushed = false; history.back();}
      else if (links.some(link => '#' + link.dataset.artworkId === location.hash)) {
        const url = new URL(location.href); url.hash = 'sl-art'; history.replaceState(history.state, '', url);
      }
    };
    const move = direction => {
      const target = Math.max(0, Math.min(count - 1, index + direction));
      track.scrollTo({left:target * track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
    };
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const wasOpen = dialog.open;
      open(link);
      if (!wasOpen) {
        const url = new URL(location.href); url.hash = link.dataset.artworkId;
        history.pushState({artworkViewer:true}, '', url); pushed = true;
      }
    }));
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    dialog.querySelector('.ss-artwork-back').addEventListener('click', dismiss);
    dialog.addEventListener('cancel', event => {event.preventDefault(); dismiss();});
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);}
    });
    window.addEventListener('resize', () => {
      if (dialog.open) {track.scrollTo({left:index * track.clientWidth,behavior:'instant'}); update();}
    });
    window.addEventListener('popstate', () => {
      const link = links.find(item => '#' + item.dataset.artworkId === location.hash);
      if (link) {pushed = Boolean(history.state && history.state.artworkViewer); open(link);}
      else {pushed = false; close();}
    });
    const initial = links.find(link => '#' + link.dataset.artworkId === location.hash);
    if (initial) open(initial);
  };
  document.querySelectorAll('.ss-gallery').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ss-gallery').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-slime"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sl-hero-carousel').forEach(carousel=>{
 const slides=[...carousel.querySelectorAll('[data-hero-slide]')],toggle=carousel.querySelector('[data-hero-toggle]'),position=carousel.querySelector('.sl-hero-position'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let index=0,timer=null,paused=reduced.matches;
 const paint=()=>{slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});position.textContent=(index+1)+' / '+slides.length;};
 const stop=()=>{if(timer)clearInterval(timer);timer=null;};
 const label=()=>{toggle.textContent=paused?carousel.dataset.playLabel:carousel.dataset.pauseLabel;};
 const run=()=>{stop();if(!paused&&!document.hidden)timer=setInterval(()=>{index=(index+1)%slides.length;paint();},3500);label();};
 const pause=()=>{paused=true;stop();label();};
 const move=direction=>{pause();index=(index+direction+slides.length)%slides.length;paint();};
 carousel.querySelector('[data-hero-prev]').addEventListener('click',()=>move(-1));
 carousel.querySelector('[data-hero-next]').addEventListener('click',()=>move(1));
 toggle.addEventListener('click',()=>{paused=!paused;run();});
 carousel.addEventListener('focusin',event=>{if(event.target!==toggle)pause();});
 carousel.addEventListener('mouseenter',()=>{stop();});
 carousel.addEventListener('mouseleave',()=>{run();});
 carousel.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else run();});
 reduced.addEventListener('change',event=>{if(event.matches)pause();});
 paint();run();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-wall-clings"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ss-wall-clings').forEach(section=>{
 const track=section.querySelector('.ss-wall-track'),cards=[...track.children],prev=section.querySelector('[data-wall-prev]'),next=section.querySelector('[data-wall-next]'),position=section.querySelector('.ss-wall-position');
 const step=()=>cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
 const update=()=>{position.textContent=(Math.round(track.scrollLeft/step())+1)+' / '+cards.length;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
 const move=d=>track.scrollBy({left:d*step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});update();
});

  } catch(e) { console.error(e); }
})();
})();
